const signInForms = (): void => {
  const formContainer = document.querySelector('[data-form-container]');
  const formToggles = document.querySelectorAll('[data-form-toggle]');

  formToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      formToggles.forEach((otherToggle) => {
        otherToggle.setAttribute('data-form-status', 'hidden');
      });
      const formType = toggle.getAttribute('data-form-type');
      formContainer.setAttribute('data-visible-form', formType);
      toggle.setAttribute('data-form-status', 'active');
    });
  });

  const registrationForm = document.querySelector('#registration-form');
  if (registrationForm) {
    const formErrors = registrationForm.querySelector('.form__field--errors');
    if (formErrors) {
      formContainer.setAttribute('data-visible-form', 'register');
      formToggles.forEach((toggle) => {
        toggle.setAttribute('data-form-status', 'hidden');
        if (toggle.getAttribute('data-form-type') == 'register') {
          toggle.setAttribute('data-form-status', 'active');
        }
      });
    }
  }
};
export default signInForms;
